import { useMutation } from "@apollo/client/react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";

import { constantsData, statusTypesData } from "@/data";
import { editReleaseOwnershipMutation, getReleaseQuery } from "@/graph";
import { openAlert } from "@/redux/actions";
import { displayErrorHandler } from "@/utils";

const useEditReleaseOwnership = (id, releaseId) => {
    const { t } = useTranslation();

    const dispatch = useDispatch();

    const [editReleaseOwnershipAction, { loading }] = useMutation(editReleaseOwnershipMutation, {
        awaitRefetchQueries: true,
        refetchQueries: [
            {
                query: getReleaseQuery,
                variables: {
                    where: { id: releaseId },
                },
            },
        ],
    });

    const editReleaseOwnership = async ({ cLine, label, pLine, territory }) => {
        try {
            await editReleaseOwnershipAction({
                onCompleted: () => {
                    dispatch(
                        openAlert(
                            t("messages.editMsgs.success", {
                                entity: `${t("releases.entity")} ${t("labels.ownership")}`,
                            }),
                            statusTypesData.success,
                        ),
                    );
                },
                variables: {
                    data: {
                        c_line: { set: cLine },
                        label: { set: label },
                        p_line: { set: pLine },
                        territory: {
                            connect: { id: territory },
                        },
                    },
                    where: { id },
                },
            });
        } catch (err) {
            displayErrorHandler(
                err.message === constantsData.failedToFetch ? t("messages.networkFailure") : err.message,
                dispatch,
                openAlert,
            );
        }
    };

    return {
        editReleaseOwnership,
        loading,
    };
};

export default useEditReleaseOwnership;
